module.exports = __webpack_public_path__ + "img/gifting.ca5740e1.png";